<div class="title">
    {{user? 'Update User' : 'Add User'}}
</div>

<form (submit)="submit($event)">
    <mat-form-field>
        <input matInput
               [formField]="userForm.email"
               placeholder="Email">
        <mat-error><app-field-errors [formField]="userForm.email"></app-field-errors></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline"
                    id="role">
        <mat-label>Role</mat-label>
        <mat-select [formField]="userForm.role">
            @for (role of ROLES; track role) {
                <mat-option [value]="role">
                    {{role}}
                </mat-option>
            }
        </mat-select>
        <mat-error><app-field-errors [formField]="userForm.role"></app-field-errors></mat-error>
    </mat-form-field>

    <mat-checkbox [formField]="userForm.active"
                  id="active"
                  [matTooltip]="getCheckboxTooltip()">Active</mat-checkbox>

    <div class="actions">
        <button mat-raised-button
                color="primary"
                [disabled]="userForm().invalid() || !hasChanged()"
                type="submit"
                mat-dialog-close="">Submit</button>
        <button mat-raised-button
                type="button"
                mat-dialog-close="">Cancel</button>
    </div>
</form>
